import { dateToYearMonth, simpleAlert } from "components/CommonLib/CommonLib";
import ComboBox from "components/LabelInput/ComboBox";
import MonthPicker from "components/LabelInput/MonthPicker";
import Loading from "components/Loading/Loading/Loading";
import NormalBtn from "components/NewButton/NormalBtn";
import { useCreateSalaryReport, useSalaryReportCreateParam } from "hooks/apis/salary/useSalaryList";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { salaryReportPost } from "./CreateReportApi";

const CreateSalaryReport = (props) => {
  // const { modalParam, onModalDone, curPage, searchList, maxPage, onClickSearchEvent } = props;
  const { modalParam, onModalDone } = props;
  const labelWidth = "3rem";
  const compWidth = "11.5rem";
  const [hqIdx, setHqIdx] = useState(0);
  const storesDispatch = useDispatch();
  const [createParam, setCreateParam] = useState(salaryReportPost);

  const { mutate: mutateCreateSalaryReport, isLoading } = useCreateSalaryReport(onModalDone);
  const { data: salaryReportCreateParam } = useSalaryReportCreateParam();

  useEffect(() => {
    if (createParam.combo_selector.target_list.length > 0) {
      createParam.hq_info = createParam.combo_selector.target_list[hqIdx].hq_info;
      createParam.branch_info = createParam.combo_selector.target_list[hqIdx].branch_list[0];
      createParam.base_date = dateToYearMonth(new Date());
    }
  }, [createParam]);

  const onClickCreateBtn = () => {
    // validation
    if (
      !createParam.hq_info.hq_id ||
      !createParam.branch_info.branch_id ||
      !createParam.base_date
    ) {
      simpleAlert(storesDispatch, "알림", "입력되지 않은 값이 있습니다.");
      return;
    }

    // do create
    const popupText =
      "[" +
      createParam.branch_info.branch_name +
      "] 지점의 " +
      createParam.base_date +
      "월 급여를 생성하시겠습니까?";
    simpleAlert(storesDispatch, "알림", popupText, false, undefined, () =>
      mutateCreateSalaryReport(createParam),
    );
  };

  useEffect(() => {
    if (salaryReportCreateParam) {
      setCreateParam(salaryReportCreateParam.data.data);
    }
  }, [salaryReportCreateParam]);

  return (
    <div>
      {isLoading && <Loading />}
      <div style={{ display: "flex" }}>
        <div>
          <ComboBox
            labelWidth={labelWidth}
            comboItemWidth={compWidth}
            labelText="본부"
            data={createParam.combo_selector.hq_list}
            defaultValue={
              createParam.combo_selector.hq_list.length > 0 &&
              createParam.combo_selector.hq_list[hqIdx]
            }
            onChangeCallback={(e) => {
              const idx = createParam.combo_selector.hq_list.findIndex(
                (el) => el === e.target.value,
              );
              setHqIdx(idx);
              createParam.hq_info = createParam.combo_selector.target_list[idx].hq_info;

              // 본부 선택 시 해당 본부의 첫번째 지점 선택
              if (createParam.combo_selector.target_list[idx].branch_list.length > 0) {
                createParam.branch_info =
                  createParam.combo_selector.target_list[idx].branch_list[0];
              }
            }}
          />
        </div>
        <div style={{ marginLeft: "2rem" }}>
          <ComboBox
            labelWidth={labelWidth}
            comboItemWidth={compWidth}
            labelText="지점"
            data={createParam.combo_selector.branch_list[hqIdx]}
            defaultValue={
              createParam.combo_selector.branch_list.length > 0 &&
              createParam.combo_selector.branch_list[hqIdx][0]
            }
            onChangeCallback={(e) => {
              const branchIdx = createParam.combo_selector.branch_list[hqIdx].findIndex(
                (el) => el === e.target.value,
              );
              createParam.branch_info =
                createParam.combo_selector.target_list[hqIdx].branch_list[branchIdx];
            }}
          />
        </div>
        <div style={{ display: "flex", marginLeft: "2rem" }}>
          <MonthPicker
            labelWidth={"4.5rem"}
            minWidth={"9rem"}
            labelText="보고서 연월"
            defaultValue={dateToYearMonth(new Date())}
            onChangeCallback={(e) => {
              createParam.base_date = e;
            }}
          />
        </div>
      </div>

      <div style={{ display: "flex", marginTop: "2rem", justifyContent: "center", gap: "0.5rem" }}>
        <NormalBtn name="확인" onClick={() => onClickCreateBtn()} />
        <NormalBtn name="취소" theme="white" onClick={() => onModalDone(false)} />
      </div>
    </div>
  );
};
export default CreateSalaryReport;
